export enum TarafRol {
    ALACAKLI = 21,
    BORCLU = 22,
    UCUNCU_SAHIS = 26,
    ARACI_KISI_KURUM = 71
}